import { TiresWarrantyEffect } from "./tires-warranty.effect";

export const effects: any[] = [
  TiresWarrantyEffect
]
